import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

export default class MeasurementComboBox extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.defaultMeasurements = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

    this.generateMeasurementOptions = this.generateMeasurementOptions.bind(this);
  }

  generateMeasurementOptions() {
    const measurements = _.get(this.props, 'measurements', this.defaultMeasurements);

    return _.reduce(measurements, (acc, measurement) => {
      acc.push(<option key={measurement} value={measurement}>{measurement}</option>);
      return acc;
    }, []);
  }

  render() {
    return (
      <FormControl className="comboBoxControl" name={this.props.name} value={this.props.selected} componentClass="select" onChange={this.props.onChange} placeholder="select">
        <option value="" disabled>{this.props.displayName}</option>
        {this.generateMeasurementOptions()}
      </FormControl>
    );
  }
}

MeasurementComboBox.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func,
  measurements: PropTypes.arrayOf(
    PropTypes.oneOf(['XS', 'S', 'M', 'L', 'XL', 'XXL']),
  ),
};

MeasurementComboBox.defaultProps = {
  selected: '',
};
